// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Lightweight_TheComp__N7o9W"};